import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Fetches and tracks the user's daily message quota from GET /api/usage/.
 *
 * Returns:
 *   usage        – raw API response: { message_count, daily_limit, plan, resets_at }
 *   loading      – true on first fetch
 *   refetch      – call this after each AI response to keep the counter fresh
 *   isAtLimit    – true when message_count >= daily_limit
 *   isNearLimit  – true when >= 80% used (to show a warning)
 */
export function useUsageQuota() {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/usage/`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setUsage(res.data);
    } catch (err) {
      console.error('Failed to fetch usage quota:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const isAtLimit = usage ? usage.message_count >= usage.daily_limit : false;
  const isNearLimit = usage
    ? !isAtLimit && usage.message_count >= Math.floor(usage.daily_limit * 0.8)
    : false;

  return { usage, loading, refetch, isAtLimit, isNearLimit };
}
